import React from 'react';
import { AudioType } from '../../../../dorian-shared/types/audio/audio';
import { SFXActionSettings } from '../../../../dorian-shared/types/audio/AudioStepSettingsType';
import { AudioTrackPicker } from '../AudioTrackPicker/AudioTrackPicker';

export type AudioSFXSettingsProps = {
  value: SFXActionSettings;
  onChange: (value: SFXActionSettings) => void;
  focused?: boolean;
  disabled?: boolean;
};

export function AudioSFXSelect(props: AudioSFXSettingsProps) {
  const { value, onChange, disabled } = props;
  return (
    <AudioTrackPicker
      audioType={AudioType.SFX}
      value={value}
      onChange={(next) => onChange(next as SFXActionSettings)}
      disabled={disabled}
    />
  );
}
